import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import { Icon } from '@iconify/react';

export const IconBundle = IconBundleBlueprint.make({
  name: 'ipen',
  params: {
    icons: {
      'dashboards': () => <Icon icon="material-symbols:show-chart" />,
      'grid-3x2': () => <Icon icon="bi:grid-3x2" />,
    },
  },
});
